import React from 'react'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import * as UI from 'ui'
import { CardGroup, CardWithHeader } from 'ui'
import { ChecklistName } from 'support/displays/ChecklistName'
import * as Displays from 'support/displays'
import CopyChecklistTemplateButton from 'pages/app/checklists/CopyChecklistTemplateButton'

export default function ChecklistTemplateListView () {
  return (
    <CardGroup>
      <ForEachModel>
        <CardWithHeader header={<Displays.Enum name="key" enum="employment_type_category"/>}>
          <Translator namespace="checklists.columns">
            <ValueToCollection name="collection">
              <Table>
                <Columns.Text
                  name="list"
                  label={<Translation name="list"/>}
                  display={<ChecklistName/>}
                />
                <Columns.Text
                  name="department.name"
                  label={<Translation name="department"/>}
                />
                <Columns.Enum
                  name="employment_category"
                  enum="employment_type_category"
                  label={<Translation name="category"/>}
                />
                <Columns.Column alignment="right">
                  <UI.ButtonWrap>
                    <CopyChecklistTemplateButton/>
                    <UI.SquareButton color="lightgray">
                      <UI.Icons.Settings/>
                    </UI.SquareButton>
                  </UI.ButtonWrap>
                </Columns.Column>
              </Table>
            </ValueToCollection>
          </Translator>
        </CardWithHeader>
      </ForEachModel>
    </CardGroup>
  )
}
